import React from 'react'

const Video = () => {
  return (
    <section className="video" id="pricing">
    <div className="container">
      <p className="title">
        When a man's stomach is full it makes no difference whether he is
        rich or poor.
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et
        purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat
        tellus.
      </p>
    </div>
  </section>
  )
}

export default Video